import React, { FC } from 'react'
import DealCommentsLogContainer from 'containers/Deal/DealCommentsLog'

const DealCommentsLogPage: FC = () => <DealCommentsLogContainer />

export default DealCommentsLogPage
